module.exports = __webpack_public_path__ + "static/img/ket-renewal-tablet-sub-04@w.e2aa22e.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/ket-renewal/ket-renewal-tablet-sub-04@w.png
// module id = tjsF
// module chunks = 0